import { render, staticRenderFns } from "./Inbound.vue?vue&type=template&id=16d3aa53&scoped=true"
import script from "./Inbound.vue?vue&type=script&lang=js"
export * from "./Inbound.vue?vue&type=script&lang=js"
import style0 from "./Inbound.vue?vue&type=style&index=0&id=16d3aa53&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d3aa53",
  null
  
)

export default component.exports